module.exports = "<p ng-repeat=\"error in errors\">\n    {{error}}\n</p>\n";